<template>
  <div>
    <b-card>
      <b-tabs card>
        <b-tab title="Ampla Concorrência">
          <b-overlay :show="overlayTabela">
            <b-table responsive :items="listaClassificadosAC" :fields="fields" striped show-empty hover stacked="xl">
              <template #cell(actions)="data">
                <b-button size="sm" :disabled="detalhes" @click="
                  alertaClassificadoRemove(
                    data.item.IdClassificado,
                    data.item.NomeClassificado,
                    data.item.IdTipoClassificadoNavigation.IdTipoClassificado
                  )
                  "><font-awesome-icon icon="trash" /></b-button>
              </template>
              <template #cell(show_details)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                  <font-awesome-icon :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'
                    " />
                </b-link>
              </template>
              <template>
                <b-card>
                  <strong>Valor inscrição de vagas Ampla Concorrência:</strong>
                </b-card>
              </template>
              <template #empty>
                <div class="text-center text-muted">
                  Nenhum classificado encontrado.
                </div>
              </template>
            </b-table>
          </b-overlay>
        </b-tab>

        <b-tab title="PCD">
          <b-overlay :show="overlayTabela">
            <b-table responsive :items="listaClassificadosPCD" :fields="fields" striped show-empty hover stacked="xl">
              <template #cell(actions)="data">
                <b-button size="sm" :disabled="detalhes" @click=" 
                  alertaClassificadoRemove(
                    data.item.IdClassificado,
                    data.item.NomeClassificado,
                    data.item.IdTipoClassificadoNavigation.IdTipoClassificado
                  )
                  "><font-awesome-icon icon="trash" /></b-button>
              </template>
              <template #cell(show_details)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                  <font-awesome-icon :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'
                    " />
                </b-link>
              </template>
              <template>
                <b-card>
                  <strong>Valor inscrição de vagas Ampla Concorrência:</strong>
                </b-card>
              </template>
              <template #empty>
                <div class="text-center text-muted">
                  Nenhum classificado encontrado.
                </div>
              </template>
            </b-table>
          </b-overlay>
        </b-tab>

        <b-tab title="Cota">
          <b-overlay :show="overlayTabela">
            <b-table responsive :items="listaClassificadosCota" :fields="fields" striped show-empty hover stacked="xl">
              <template #cell(actions)="data">
                <b-button size="sm" :disabled="detalhes" @click="
                  alertaClassificadoRemove(
                    data.item.IdClassificado,
                    data.item.NomeClassificado,
                    data.item.IdTipoClassificadoNavigation.IdTipoClassificado
                  )
                  "><font-awesome-icon icon="trash" /></b-button>
              </template>
              <template #cell(show_details)="row">
                <b-link class="text-dark" @click="row.toggleDetails">
                  <font-awesome-icon :icon="row.detailsShowing ? 'chevron-down' : 'chevron-right'
                    " />
                </b-link>
              </template>
              <template>
                <b-card>
                  <strong>Valor inscrição de vagas Ampla Concorrência:</strong>
                </b-card>
              </template>
              <template #empty>
                <div class="text-center text-muted">
                  Nenhum classificado encontrado.
                </div>
              </template>
            </b-table>
          </b-overlay>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script lang="ts">
import { PropType } from "vue";
import { UtilsTS } from "@/utilsts";
import { mixins } from "vue-class-component";
import { TableField } from "@/types/table-field";
import { Component, Vue } from "vue-property-decorator";
import concursoService from "@/services/atos-pessoal/concursoService";
import { Classificado } from "@/types/atos-pessoal/concursos/classificado";
import { fieldsTabelaClassificados } from "@/types/atos-pessoal/concursos/fields-tabela-classificados";

const CompProps = Vue.extend({
  name: "TabelaClassificadosEdital",
  props: {
    classificados: {
      type: Array as PropType<Classificado[]>,
      default: () => [],
      required: true,
    },
    detalhes: {
      type: Boolean,
      default: false,
    }
  },
});

@Component
export default class TabelaClassificadosEdital extends mixins(
  UtilsTS,
  CompProps
) {
  fields: TableField[] = fieldsTabelaClassificados

  listaClassificadosGeral: Classificado[] = [];
  listaClassificadosAC: Classificado[] = [];
  listaClassificadosPCD: Classificado[] = [];
  listaClassificadosCota: Classificado[] = [];

  overlayTabela = false;

  mounted() {
    this.listaClassificadosGeral = this.classificados;
    this.listaClassificadosGeral = this.listaClassificadosGeral.sort(
      (a, b) =>
        a.IdTipoClassificadoNavigation.IdTipoClassificado -
        b.IdTipoClassificadoNavigation.IdTipoClassificado
    );
    this.dividirListas();
  }

  //Dividir as listas por modalidade
  async dividirListas() {
    //Separando por modalidade
    this.listaClassificadosAC = this.listaClassificadosGeral.filter(
      (classificado) =>
        classificado.IdTipoClassificadoNavigation.IdTipoClassificado === 1
    );
    this.listaClassificadosPCD = this.listaClassificadosGeral.filter(
      (classificado) =>
        classificado.IdTipoClassificadoNavigation.IdTipoClassificado === 2
    );
    this.listaClassificadosCota = this.listaClassificadosGeral.filter(
      (classificado) =>
        classificado.IdTipoClassificadoNavigation.IdTipoClassificado === 3
    );

    //ordenando por posição
    this.listaClassificadosAC = this.listaClassificadosAC.sort(
      (a, b) => a.NrClassificacao - b.NrClassificacao
    );
    this.listaClassificadosPCD = this.listaClassificadosPCD.sort(
      (a, b) => a.NrClassificacao - b.NrClassificacao
    );
    this.listaClassificadosCota = this.listaClassificadosCota.sort(
      (a, b) => a.NrClassificacao - b.NrClassificacao
    );
  }

  //Excluir classificado
  async excluirClassificado(idClassificado: number, modalidade: number) {
    try {
      this.overlayTabela = true;
      await concursoService.excluirClassificado(idClassificado);
      this.$toast.success("Classificado excluído com sucesso!");

      //Removendo os itens excluídos da lista localmente
      if (modalidade === 1)
        this.listaClassificadosAC = this.listaClassificadosAC.filter(
          (a: Classificado) => a.IdClassificado !== idClassificado
        );
      if (modalidade === 2)
        this.listaClassificadosPCD = this.listaClassificadosPCD.filter(
          (a: Classificado) => a.IdClassificado !== idClassificado
        );
      if (modalidade === 3)
        this.listaClassificadosCota = this.listaClassificadosCota.filter(
          (a: Classificado) => a.IdClassificado !== idClassificado
        );
    } catch (e: any) {
      this.tratarError(e);
    } finally {
      this.overlayTabela = false;
    }
  }

  alertaClassificadoRemove(
    idClassificado: number,
    nomeClassificado: string,
    modalidade: number
  ) {
    if (this.detalhes) return
    this.$bvModal.msgBoxConfirm(`Deseja remover o classificado ${nomeClassificado}?`, {
      buttonSize: "sm",
      cancelTitle: "Cancelar",
      cancelVariant: "outline-secondary",
      centered: true,
      headerBgVariant: "secondary",
      headerTextVariant: "light",
      okTitle: "Confirmar",
      okVariant: "secondary",
      title: "Remover cargo",
    })
      .then((value) => {
        if (value) this.excluirClassificado(idClassificado, modalidade);
      })
      .catch((error) => {
        console.error(`Erro ao operar o dialogo de alerta de remoção de classificado`, error);
      });
  }
}
</script>
